module.exports = __webpack_public_path__ + "static/global-team-dark-2-fa3dcc8dac1ba0b6f836e8142842e6c1.png";